import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext.js";
import "./styles/AdminProfile.css";

const AdminProfile = () => {
  const { user } = useContext(AuthContext);

  const getRoleLabel = (role) => {
    const labels = {
      admin: "Administrator",
      journalist: "Journalist",
      reporter: "Reporter",
      user: "Subscriber",
      freemium: "Free Account"
    };
    return labels[role] || role;
  };

  return (
    <div className="admin-layout">
      <div className="admin-layout-inner">
        <div className="admin-page-header">
          <h1>Admin Profile</h1>
          <p>Your account information and settings</p>
        </div>

        <div className="admin-card" style={{ maxWidth: "600px" }}>
          <div className="admin-card-header">
            <h2>Account Information</h2>
          </div>
          <div className="admin-card-body">
            <div className="admin-info-grid">
              <div className="admin-info-item">
                <span className="admin-info-label">Username</span>
                <span className="admin-info-value">{user?.username}</span>
              </div>
              <div className="admin-info-item">
                <span className="admin-info-label">Role</span>
                <span className="admin-info-value">
                  <span className={`admin-badge admin-badge-${user?.role}`}>{getRoleLabel(user?.role)}</span>
                </span>
              </div>
              {user?.display_name && (
                <div className="admin-info-item">
                  <span className="admin-info-label">Display Name</span>
                  <span className="admin-info-value">{user.display_name}</span>
                </div>
              )}
              {user?.email && (
                <div className="admin-info-item">
                  <span className="admin-info-label">Email</span>
                  <span className="admin-info-value">{user.email}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminProfile;
